import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { routesArray } from "../routes/towne.public.routes";

import { authStorage, localStorageToken, localStorageUser } from "../utils/variables";

const AxiosConfigurations = () => {
  // Hooks

  const history = useHistory();

  // States

  const [renderedToast, setRenderedToast] = useState(null);

  const setAxiosReqConfig = () => {
    return axios.interceptors.request.use(
      (config) => {
        const originApp = process.env.REACT_APP_ORIGIN_APP || "admin-app";
        config.headers = config.headers || {};
        
        // Only add X-Origin-Application header for internal API calls (towne.io)
        // Skip for external APIs like Google Maps to avoid CORS issues
        const isInternalApi = config.url && (
          config.url.includes('towne.io') || 
          config.url.includes('localhost:4000')
        );
        
        if (isInternalApi) {
          config.headers["X-Origin-Application"] = originApp;
        }
        
        return config;
      },
      (error) => Promise.reject(error)
    );
  };

  const setAxiosResConfig = () => {
    return axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (
          (error.response?.status === 403 || error.response?.status === 401) &&
          !routesArray.includes(window.location.pathname)
        ) {
          authStorage.removeItem(localStorageToken);
          authStorage.removeItem(localStorageUser);
          if (!renderedToast) {
            const toastId = toast.error("Session expired! Logging you out.", {
              autoClose: 3000,
              hideProgressBar: false,
              position: "top-center",
            });
            setRenderedToast(toastId);
          }
          history.push("/login");
        } else {
          throw error;
        }
      }
    );
  };

  setAxiosReqConfig();
  setAxiosResConfig();

  return null;
};

export default AxiosConfigurations;
